function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 0h140v140H0z"
}), React.createElement("linearGradient", {
  id: "c",
  x1: "48.497%",
  x2: "50.051%",
  y1: "21.486%",
  y2: "80.396%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E4E4"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#818181"
})), React.createElement("linearGradient", {
  id: "d",
  x1: "-11.302%",
  x2: "50%",
  y1: "-25.267%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E4E4"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#818181"
})), React.createElement("linearGradient", {
  id: "g",
  x1: "52.742%",
  x2: "53.281%",
  y1: "2.87%",
  y2: "97.126%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#C3C3C3"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#949494"
})), React.createElement("path", {
  id: "e",
  d: "M81.509 40.574c0 22.408-18.153 40.574-40.545 40.574C18.572 81.148.419 62.982.419 40.574.419 18.166 18.572 0 40.964 0c22.392 0 40.545 18.166 40.545 40.574z"
}), React.createElement("filter", {
  id: "f",
  width: "129.6%",
  height: "129.6%",
  x: "-14.8%",
  y: "-14.8%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 4
}), React.createElement("feOffset", {
  dx: -16,
  dy: -1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1",
  values: "0 0 0 0 0.862670068 0 0 0 0 0.862670068 0 0 0 0 0.862670068 0 0 0 1 0"
}), React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner2",
  stdDeviation: 2
}), React.createElement("feOffset", {
  dy: -3,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner2"
}), React.createElement("feColorMatrix", {
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.183622056 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), React.createElement("linearGradient", {
  id: "h",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#CECFD0"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#9F9F9F"
})), React.createElement("ellipse", {
  id: "i",
  cx: 55.096,
  cy: 113.397,
  rx: 5.56,
  ry: 3.003
}), React.createElement("filter", {
  id: "j",
  width: "127%",
  height: "150%",
  x: "-13.5%",
  y: "-25%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dx: 1,
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0.524845876 0 0 0 0 0.524845876 0 0 0 0 0.524845876 0 0 0 0.5 0"
})), React.createElement("ellipse", {
  id: "k",
  cx: 25.41,
  cy: 102.891,
  rx: 5.56,
  ry: 3.003
}), React.createElement("filter", {
  id: "l",
  width: "127%",
  height: "150%",
  x: "-13.5%",
  y: "-25%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dx: 1,
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0.524845876 0 0 0 0 0.524845876 0 0 0 0 0.524845876 0 0 0 0.5 0"
})), React.createElement("linearGradient", {
  id: "m",
  x1: "15.815%",
  x2: "69.598%",
  y1: "45.134%",
  y2: "80.396%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E4E4"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#818181"
})), React.createElement("linearGradient", {
  id: "n",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#CECFD0"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#9F9F9F"
})), React.createElement("ellipse", {
  id: "o",
  cx: 4.196,
  cy: 26.837,
  rx: 3.794,
  ry: 2.86
}), React.createElement("filter", {
  id: "p",
  width: "113.2%",
  height: "117.5%",
  x: "-6.6%",
  y: "-8.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dx: 1,
  dy: -1,
  in: "SourceAlpha",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0.524845876 0 0 0 0 0.524845876 0 0 0 0 0.524845876 0 0 0 0.5 0"
})), React.createElement("filter", {
  id: "q",
  width: "110.2%",
  height: "199.9%",
  x: "-5.1%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 1.3
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-25 -22)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("g", {
  mask: "url(#b)"
}, React.createElement("g", {
  transform: "translate(13 10)"
}, React.createElement("path", {
  stroke: "url(#c)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.95,
  d: "M57.385 74.213l.428 38.449",
  transform: "translate(.013)"
}), React.createElement("path", {
  stroke: "url(#d)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.95,
  d: "M53.989 76.485S40.319 87.88 34.031 94.763c-2.364 2.587-5.997 10.134-5.997 10.134",
  transform: "translate(.013)"
}), React.createElement("g", {
  transform: "rotate(21 14.678 79.489)"
}, React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#e"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#f)",
  xlinkHref: "#e"
}), React.createElement("path", {
  stroke: "url(#g)",
  strokeLinejoin: "square",
  strokeWidth: 1.3,
  d: "M12.754 12.343C19.974 5.12 29.947.65 40.964.65c11.016 0 20.99 4.469 28.21 11.693 7.22 7.225 11.685 17.206 11.685 28.231 0 11.025-4.466 21.006-11.686 28.23-7.219 7.225-17.193 11.694-28.21 11.694-11.016 0-20.99-4.469-28.209-11.693C5.534 61.58 1.07 51.599 1.07 40.574c0-11.025 4.465-21.006 11.685-28.23z"
})), React.createElement("g", {
  transform: "rotate(21 -52.664 70.645)"
}, React.createElement("ellipse", {
  cx: 2.791,
  cy: 8.218,
  fill: "#8B8B8B",
  rx: 1.607,
  ry: 2.992,
  transform: "rotate(9 2.79 8.218)"
}), React.createElement("ellipse", {
  cx: 13.064,
  cy: 5.704,
  fill: "#8B8B8B",
  rx: 2.607,
  ry: 3.903,
  transform: "rotate(16 13.064 5.704)"
}), React.createElement("path", {
  stroke: "#A7A7A7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M.246 20.714S1.755 30.91 5.36 33.681c3.606 2.772 8.56-.767 10.57-12.967"
})), React.createElement("g", {
  transform: "rotate(165 55.102 113.398)"
}, React.createElement("use", {
  fill: "url(#h)",
  xlinkHref: "#i"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#j)",
  xlinkHref: "#i"
}), React.createElement("ellipse", {
  cx: 55.096,
  cy: 113.397,
  stroke: "#979797",
  strokeLinejoin: "square",
  strokeWidth: 0.65,
  rx: 5.235,
  ry: 2.678
})), React.createElement("g", {
  transform: "rotate(46 25.417 102.906)"
}, React.createElement("use", {
  fill: "url(#h)",
  xlinkHref: "#k"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#l)",
  xlinkHref: "#k"
}), React.createElement("ellipse", {
  cx: 25.41,
  cy: 102.891,
  stroke: "#979797",
  strokeLinejoin: "square",
  strokeWidth: 0.65,
  rx: 5.235,
  ry: 2.678
})), React.createElement("g", null, React.createElement("path", {
  stroke: "url(#m)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.95,
  d: "M22.105.403S32.71 20.968 6.511 27.07",
  transform: "translate(39.708 48.44)"
}), React.createElement("g", {
  transform: "rotate(-9 331.8 -201.21)"
}, React.createElement("use", {
  fill: "url(#n)",
  xlinkHref: "#o"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#p)",
  xlinkHref: "#o"
}), React.createElement("ellipse", {
  cx: 4.196,
  cy: 26.837,
  stroke: "#979797",
  strokeLinejoin: "square",
  strokeWidth: 0.65,
  rx: 3.469,
  ry: 2.535
}))), React.createElement("ellipse", {
  cx: 75.216,
  cy: 116.097,
  fill: "#919191",
  fillOpacity: 0.238,
  filter: "url(#q)",
  rx: 38.115,
  ry: 3.903
}))));

var SvgNoContent = function SvgNoContent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 103,
    height: 111,
    viewBox: "0 0 103 111",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-content.2720dc9e.svg";
export { ForwardRef as ReactComponent };